import { Cart } from 'react-bootstrap-icons';

interface CartIconProps {
    items: number;
    clickfunc: () => void;
}

function CartIcon({items, clickfunc}: CartIconProps){
    return (
        /* Need to write code to capture half stars */
        <> 
            <div className="d-inline-block ">
                <Cart onClick={clickfunc} size={24} /><p className="d-inline-block smallest-copy-style text-font-body my-0">({items})</p>
            </div>
        </>
    )
}

export default CartIcon;